import { RootState } from '~/store';

export const getImagesReducer = (state: RootState) => state.imagesReducer;
